export const FETCH_NOTIFICATIONS_START = 'FETCH_NOTIFICATIONS_START';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';

export const RESET_NOTIFICATIONS_LIST = 'RESET_NOTIFICATIONS_LIST';

export const SELECT_NOTIFICATIONS_ITEM = 'SELECT_NOTIFICATIONS_ITEM';